"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
var _paulCorePackage = require("paul-core-package");
var _reactRedux = require("react-redux");
var _react = require("react");
var _selectors = require("../redux/selectors");
var _actions = require("../redux/actions");
const {
  ComponentTypes,
  regularByDeviceProductCodeList
} = _paulCorePackage.constants;
const useSetActiveFilter = () => {
  const dispatch = (0, _reactRedux.useDispatch)();
  const hasActiveFilter = Boolean((0, _reactRedux.useSelector)(_selectors.selectActiveDeviceId));
  const devicesById = (0, _reactRedux.useSelector)(_selectors.selectDevicesById);
  const devices = (0, _paulCorePackage.useDeepMemo)(() => Object.values(devicesById).filter(item => item.equipmentType === ComponentTypes.PwcPoe && regularByDeviceProductCodeList.smartValveFlush.test(item.thingPaulProductCode)), [devicesById]);
  (0, _react.useEffect)(() => {
    if (!hasActiveFilter && devices.length) {
      dispatch((0, _actions.setActiveDeviceId)(devices[0].thingPDIDDevice));
    }
  }, [dispatch, devices, hasActiveFilter]);
};
var _default = exports.default = useSetActiveFilter;